import { render, staticRenderFns } from "./ContactPhoto.vue?vue&type=template&id=4066e356&"
import script from "./ContactPhoto.vue?vue&type=script&lang=js&"
export * from "./ContactPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports